<template>
  <label
    v-if="item[field]"
    :class="[$style.text, getLabelClasses()]"
  >
    New
  </label>
  <label
    v-else
    :class="[$style.text, getLabelClasses()]"
  >
    Imported
  </label>
</template>
<script>
export default {
  name: 'ImportStatus',
  props: {
    field: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getLabelClasses() {
      if (this.item[this.field]) {
        return this.$style.new;
      }
      return this.$style.imported;
    },
  },
};
</script>
<style module>
@value (
  jcGrey800
) from '~css/brand-colors.css';

.text {
  padding: 5px 0;
}

.new {
  font-weight: bold;
}

.imported {
  color: jcGrey800;
}
</style>
